import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { EventsManager } from '../../events/events.manager';
import { HeroComponent } from '../hero/hero.component';
import { NgIf,CommonModule } from '@angular/common';
import { CardItemComponent } from '../common/card-item/card-item.component';
import { PlansService } from 'src/app/services/plans.service';
import { PhonePipe } from '../../pipes/phone.pipe';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ValidateEmail } from '../validators/form-validator';
import { ContactUsRequestModel } from 'src/app/models/contact-us.request.model';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { RouterLink } from '@angular/router';
import {MarketingDetailsRequest} from "../../models/MarketingDetailRequest";

@Component({
  selector: 'app-adha',
  standalone: true,
  imports: [CommonModule, HeroComponent, NgIf, CardItemComponent,FormsModule, ReactiveFormsModule, PhonePipe,RouterLink],
  templateUrl: './adha.component.html',
  styleUrl: './adha.component.scss'
})

export class AdhaComponent implements OnInit {
showDetails: boolean = true;
details:any = {}; //will clean this up next time we touch this site
info:any = {}; // same as above
  marketingDetails:any = {};
showContactSuccess:boolean = false;
showContactError:boolean = false;
viewSavingsUrl:string = '/summary-of-discounts';
planName:string = 'Smile Generation Dental Plan';

  constructor(protected em: EventsManager,private plansService:PlansService,private googleAnalyticsService: GoogleAnalyticsService) { }
contactUs: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required,Validators.minLength(3)]),
    email: new FormControl('', [Validators.required,ValidateEmail]),
    message: new FormControl('', [Validators.required,Validators.minLength(3)]),
    planName: new FormControl(this.em.planName),
    planEmail: new FormControl(this.em.planEmail),
  })
  ngOnInit(): void {
    this.em.setHideHeader(true); // Hide the top header when on the ADHA page
    this.getPlansForADHA();
    this.em.purchaseIsADHA = true;
  }

  getPlansForADHA(){
    this.plansService.getPlanOptionsByPractice(this.em.adhaPractice).subscribe(
      (result:any) => {
        this.em.planOptions = result;
        this.details = result;
        this.getHomePageDetails(this.details?.templates[0].benefitPlanTemplateId)
        this.viewSavingsUrl = '/adha/summary-of-discounts';

        if(result.templates && result.templates.length > 0){
          this.planName = result.templates[0].planName;
        }
      })
  }

  sendForm(){
      const request:ContactUsRequestModel = {name:this.contactUs.get('name')?.value,email:this.contactUs.get('email')?.value,message:this.contactUs.get('message')?.value,planName:this.contactUs.get('planName')?.value,planEmail:this.contactUs.get('planEmail')?.value};
      this.plansService.sendContactUs(request).subscribe(
        () => {
          this.showContactSuccess = true;
          this.googleAnalyticsService.sendKeyEvent('contact_us_submit', {
            timestamp: new Date().toISOString()
          });
        },
        () => {
          this.showContactError = true;
        }
      )
    }
  getHomePageDetails(planId:string){
    const request:MarketingDetailsRequest = {pageName: 'home',planId:planId};
    this.plansService.getHomePageData(request).subscribe(
      (result:any) => {
        this.em.homePageDetails = result;
        this.em.homePageDetailUpdated.emit();
        this.marketingDetails = result;
      }
    )
  }

  findDentist() {
    this.googleAnalyticsService.sendKeyEvent('find_dentist', {
      timestamp: new Date().toISOString()
    });
  }
}
